import { Component } from 'react';
import Loader from 'react-loader-spinner';
import Cookies from 'js-cookie';
import ReactPlayer from 'react-player';
import { RiPlayListAddFill } from 'react-icons/ri';
import {
  AiFillLike,
  AiOutlineLike,
  AiFillDislike,
  AiOutlineDislike,
} from 'react-icons/ai';
import {
  HomeContainer,
  VideoDetailsTextContainer,
  ProductsLoaderContainer,
  ViewsDetailsContainer,
  VideoDetailsSideContainer,
  VideoDetailsText,
  LikesContainer,
  ViewsText,
  IconContainer,
  HorizontalLine,
  ChannelLogo,
  ChannelContainer,
  ChannelDetailsContainer,
  LogoContainer,
  NotFoundContainer,
  Image,
  Heading,
  Desc,
  NavLink,
  Retry,
} from './styledComponents';

import Header from '../Header';
import CartContext from '../../context/CartContext';
import SideBar from '../SideBar';

const apiStatusConstant = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  inProgress: 'IN_PROGRESS',
  failure: 'FAILURE',
};

class VideoDetails extends Component {
  state = {
    apiStatus: apiStatusConstant.initial,
    videoDetails: {},
    isVideoSaved: false,
    isLiked: false,
    isDisLiked: false,
  };

  componentDidMount() {
    this.getVideoDetails();
  }

  getVideoDetails = async () => {
    const { match } = this.props;
    const { params } = match;
    const { id } = params;

    this.setState({ apiStatus: apiStatusConstant.inProgress });

    const jwtToken = Cookies.get('jwt_token');
    const apiUrl = `https://apis.ccbp.in/videos/${id}`;
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    };

    const response = await fetch(apiUrl, options);
    if (response.ok) {
      const fetchedData = await response.json();
      const updatedData = {
        id: fetchedData.video_details.id,
        title: fetchedData.video_details.title,
        videoUrl: fetchedData.video_details.video_url,
        thumbnailUrl: fetchedData.video_details.thumbnail_url,
        channel: {
          name: fetchedData.video_details.channel.name,
          profileImageUrl: fetchedData.video_details.channel.profile_image_url,
          subscriberCount: fetchedData.video_details.channel.subscriber_count,
        },
        viewCount: fetchedData.video_details.view_count,
        publishedAt: fetchedData.video_details.published_at,
        description: fetchedData.video_details.description,
      };
      this.setState({
        videoDetails: updatedData,
        apiStatus: apiStatusConstant.success,
      });
    } else {
      this.setState({ apiStatus: apiStatusConstant.failure });
    }
  };

  renderLoadingView = () => (
    <ProductsLoaderContainer data-testid="loader">
      <Loader type="ThreeDots" color="#0b69ff" height="50" width="50" />
    </ProductsLoaderContainer>
  );

  renderFailureView = () => (
    <NotFoundContainer>
      <Image
        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-not-found-light-theme-img.png"
        alt="failure view"
      />
      <Heading>Oops! Something Went Wrong</Heading>
      <Desc>
        We are having some trouble completing your request. Please try again.
      </Desc>
      <NavLink to="#">
        <Retry onClick={this.getVideoDetails}>Retry</Retry>
      </NavLink>
    </NotFoundContainer>
  );

  renderSpecificVideoDetails = () => (
    <CartContext.Consumer>
      {value => {
        const { videoDetails, isVideoSaved, isLiked, isDisLiked } = this.state;
        const { isDarkTheme } = value;
        const {
          id,
          title,
          videoUrl,
          channel,
          viewCount,
          publishedAt,
          description,
        } = videoDetails;
        const { name, profileImageUrl, subscriberCount } = channel;
        const { addToSaveVideos, removeSavedVideos } = value;

        const onClickLikeButton = () => {
          this.setState(prevState => ({
            isLiked: !prevState.isLiked,
            isDisLiked: false,
          }));
        };

        const onClickDislikeButton = () => {
          this.setState(prevState => ({
            isDisLiked: !prevState.isDisLiked,
            isLiked: false,
          }));
        };

        const addOrRemoveItem = () => {
          if (isVideoSaved) {
            removeSavedVideos(id);
          } else {
            addToSaveVideos({ ...videoDetails, videoSaved: true });
          }
        };

        const saveVideoToList = () => {
          this.setState(
            prev => ({ isVideoSaved: !prev.isVideoSaved }),
            addOrRemoveItem,
          );
        };

        let likeClass = '#64748b';
        if (isLiked) {
          likeClass = '#2563eb';
        } else if (isDisLiked) {
          likeClass = '#64748b';
        }

        let disLikeClass = '#64748b';
        if (isDisLiked) {
          disLikeClass = '#2563eb';
        } else if (isLiked) {
          disLikeClass = '#64748b';
        }

        const likeIcon = isLiked ? <AiFillLike /> : <AiOutlineLike />;
        const disLikeIcon = isDisLiked ? <AiFillDislike /> : <AiOutlineDislike />;

        return (
          <div data-testid="videoItemDetails">
            <Header />
            <HomeContainer isDarkTheme={isDarkTheme}>
              <SideBar />
              <VideoDetailsSideContainer>
                <ReactPlayer
                  url={videoUrl}
                  controls
                  width="90%"
                  height="500px"
                />
                <VideoDetailsTextContainer>
                  <VideoDetailsText isDarkTheme={isDarkTheme}>
                    {title}
                  </VideoDetailsText>
                  <ViewsDetailsContainer>
                    <ViewsText>{viewCount} views</ViewsText>
                    <ViewsText>{publishedAt}</ViewsText>
                    <LikesContainer>
                      <IconContainer
                        type="button"
                        color={likeClass}
                        onClick={onClickLikeButton}
                      >
                        {likeIcon}
                        <ViewsText color={likeClass}>Like</ViewsText>
                      </IconContainer>
                      <IconContainer
                        type="button"
                        color={disLikeClass}
                        onClick={onClickDislikeButton}
                      >
                        {disLikeIcon}
                        <ViewsText color={disLikeClass}>Dislike</ViewsText>
                      </IconContainer>
                      <IconContainer
                        onClick={saveVideoToList}
                        color={isVideoSaved ? '#4f46e5' : '#181818'}
                      >
                        <RiPlayListAddFill />
                        <ViewsText color={isVideoSaved ? '#4f46e5' : '#181818'}>
                          {isVideoSaved ? 'Saved' : 'Save'}
                        </ViewsText>
                      </IconContainer>
                    </LikesContainer>
                  </ViewsDetailsContainer>
                  <HorizontalLine />
                  <ChannelContainer>
                    <LogoContainer>
                      <ChannelLogo src={profileImageUrl} alt="channel logo" />
                    </LogoContainer>
                    <ChannelDetailsContainer>
                      <ViewsText>{name}</ViewsText>
                      <ViewsText>{subscriberCount} subscribers</ViewsText>
                      <ViewsText>{description}</ViewsText>
                    </ChannelDetailsContainer>
                  </ChannelContainer>
                </VideoDetailsTextContainer>
              </VideoDetailsSideContainer>
            </HomeContainer>
          </div>
        );
      }}
    </CartContext.Consumer>
  );

  renderAllVideos = () => {
    const { apiStatus } = this.state;

    switch (apiStatus) {
      case apiStatusConstant.success:
        return this.renderSpecificVideoDetails();
      case apiStatusConstant.inProgress:
        return this.renderLoadingView();
      case apiStatusConstant.failure:
        return this.renderFailureView();
      default:
        return null;
    }
  };

  render() {
    return <>{this.renderAllVideos()}</>;
  }
}

export default VideoDetails;